import { apiQueryAdapter } from "../apiQueryAdapter";
import { PageResponseModel } from "../common/models";
import {
  InboundChangeLogEntry,
  InboundChangeLogFilterParams,
} from "./inboundChangeLogModels";

const PAGE_SIZE = 50;

class InboundChangeLogService {
  private static instance: InboundChangeLogService;

  static getInstance(): InboundChangeLogService {
    if (!InboundChangeLogService.instance) {
      InboundChangeLogService.instance = new InboundChangeLogService();
    }
    return InboundChangeLogService.instance;
  }

  /**
   * Search inbound freight change audit log.
   * GET /inbound-freight/change-log
   */
  public search = async (
    filter: InboundChangeLogFilterParams = {},
    page = 0
  ): Promise<PageResponseModel<InboundChangeLogEntry>> => {
    const params: Record<string, string | number> = {
      page,
      size: filter.size ?? PAGE_SIZE,
    };
    if (filter.manifestNumber != null) params.manifestNumber = filter.manifestNumber;
    if (filter.terminalNumber != null) params.terminalNumber = filter.terminalNumber;
    if (filter.actionType) params.actionType = filter.actionType;
    if (filter.dateFrom) params.dateFrom = filter.dateFrom;
    if (filter.dateTo) params.dateTo = filter.dateTo;
    if (filter.search) params.search = filter.search;

    const response = await apiQueryAdapter.query<
      PageResponseModel<InboundChangeLogEntry>
    >("/inbound-freight/change-log", "GET", { params });

    return response.data;
  };
}

export default InboundChangeLogService.getInstance();
